module.exports = __webpack_public_path__ + "img/trend.42c87a01.jpeg";